<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import { useLayoutLoader } from '@/composables/useLayoutLoader'

const { isLoading: loading } = useLayoutLoader()
const isHeaderFixed = ref(false)

const handleScroll = () => {
  const scrollY = window.scrollY || document.documentElement.scrollTop
  isHeaderFixed.value = scrollY > 48
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <div class="bg-[#F0F2F5]">
    <!-- 👉 Header component with hide/show transition -->
    <div :class="['w-full header-transition', isHeaderFixed ? 'header-fixed' : 'header-relative']">
      <NotFoundHeader />
    </div>

    <!-- 👉 Main content area with sidebar and router view -->
    <div
      class="pt-[65px] lg:pt-[105px] bg-[url('/img/error-page-mobile.svg')] lg:bg-[url('/img/error-page.svg')] bg-no-repeat bg-cover">
      <LayoutLoader :loading="loading">
        <Container>
          <div>
            <RouterView v-slot="{ Component }">
              <transition name="fade" mode="out-in">
                <component :is="Component" />
              </transition>
            </RouterView>
          </div>
        </Container>
      </LayoutLoader>
    </div>
    <NotFoundFooter />
  </div>
</template>

<style scoped>
.header-transition {
  transition:
    transform 0.4s ease,
    opacity 0.4s ease,
    background-color 0.4s ease,
    box-shadow 0.4s ease;
}

.header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  opacity: 0.98;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(0);
  background-color: white;
}

.header-relative {
  position: relative;
  opacity: 1;
}
</style>
